import { Tooltip, TooltipProps } from '@mui/material'
import { ReactElement, ReactNode } from 'react'

interface ElementTooltipProps extends TooltipProps {
  children: ReactElement<any, any>
  title: ReactNode
}

const ElementTooltip = (props: ElementTooltipProps) => {
  const { children, title, placement } = props

  return (
    <Tooltip title={title} placement={placement} arrow>
      <div style={{ display: 'inline-flex' }}>{children}</div>
    </Tooltip>
  )
}

export default ElementTooltip
